import moment from 'moment-timezone';
import React from 'react';

import { ReactComponent as Calendar } from '../../../assets/icons/Calendar.svg';
import { Button, Tags } from '../..';
import utils from '../../../services/utils';
import { ReactComponent as Trash } from '../../../assets/icons/Trash.svg';

import classes from './CollaboratorsToPayCard.module.scss';
import { statusAccountDestination, typesStatusAccount } from '../../../store/constants/statusDruoAccounts';

const CollaboratorsToPayCard = ({ collaborator, isChecked, isPayed, deleteHandler, onClick }) => {
  const containerClasses = ['card-check', classes.content, isPayed ? classes.isPayed : ''];
  if (isChecked) {
    containerClasses.push('border-selected');
  }
  const { name, positionLabel, lastPaymentDate, salaryValue, lastPaymentValue, druoAccounts } = collaborator;

  const text =
    druoAccounts.length > 0
      ? druoAccounts[0].meloStatus !== typesStatusAccount.SUCCESS
        ? druoAccounts[0].druoStatusDescription
        : ''
      : statusAccountDestination.DISCONNECTED.label;
  //druoAccounts?.[0]?.meloStatus !== 'SUCCESS' ? druoAccounts?.[0]?.druoStatusDescription : '' || statusAccount.DISCONNECTED.label;
  const type =
    druoAccounts.length > 0
      ? druoAccounts[0].meloStatus !== typesStatusAccount.SUCCESS
        ? statusAccountDestination[druoAccounts?.[0]?.meloStatus]?.color
        : ''
      : statusAccountDestination.DISCONNECTED.label;
  //const type = statusAccount[druoAccounts?.[0]?.meloStatus]?.color || statusAccount.DISCONNECTED.color;

  return (
    <div className={containerClasses.join(' ')}>
      <div className={classes.head}>
        <div className={classes.name}>
          <Button title={name} custom='tertiary' className={`${classes.business} text-ellipsis semibold-18`} onClick={onClick}>
            {name}
          </Button>
          {<Tags text={text} type={type} />}
        </div>
        {isPayed && (
          <Button onClick={deleteHandler} Icon={Trash} custom='quaternary' color='gray'>
            Eliminar
          </Button>
        )}
      </div>
      <span className={`${classes.text} ${classes.color} medium-16`}>{positionLabel}</span>
      <div className={classes.calendar}>
        <Calendar />
        <span className={`${classes.color} medium-16`}>
          {!!lastPaymentDate
            ? `Último pago el ${moment(lastPaymentDate).format('DD/MM/YYYY')} por ${utils.moneyFormat(lastPaymentValue)}`
            : 'No se han realizado pagos'}
        </span>
      </div>
      <div className={classes.down}>
        <span className='semibold-18'>Salario neto {utils.moneyFormat(salaryValue)}</span>
        {/*!isPayed && (
          <Button onClick={onClick} custom='quaternary'>
            Ver perfil
          </Button>
        )*/}
      </div>
    </div>
  );
};

export default CollaboratorsToPayCard;
